import EducatorAccountSettings from 'educator/account-settings/components/educator-account-settings';
import React, {ComponentType} from 'react';
import MobileSubpageTitle from 'src/components/mobile-navbar/mobile-subpage-title';
import {UserType} from 'src/types/enums';
import {AdultLearnerAccountSettings} from 'src/views/adult-learner/AccountSettings';
import CollegePortalAccountSettings from 'src/views/college-portal/account-settings/college-portal-account-settings';
import HighSchoolAccountSettings from 'src/views/high-school/account-settings/high-school-account-settings';
import ParentAccountSettings from 'src/views/parent/AccountSettings/components/ParentAccountSettings';
import TransferAccountSettings from 'src/views/transfer/AccountSettings/TransferAccountSettings';
import {UndergraduateAccountSettings} from 'src/views/undergraduate/AccountSettings';
import {ACCOUNT_SETTING_ROUTES} from './utils';

// TODO: Could be moved into ACCOUNT_SETTING_ROUTES later, if they were to be used in the _AccountSettings.tsx pages
// Note: Both of these must be separated from ACCOUNT_SETTING_ROUTES to avoid circular dependencies
export const MOBILE_ACCOUNT_SETTINGS_COMPONENTS: Record<UserType, ComponentType> = {
  [UserType.HS_STUDENT]: HighSchoolAccountSettings,
  [UserType.CC_STUDENT]: TransferAccountSettings,
  [UserType.PARENT]: ParentAccountSettings,
  [UserType.UNDERGRADUATE_STUDENT]: UndergraduateAccountSettings,
  [UserType.ADULT_LEARNER]: AdultLearnerAccountSettings,
  [UserType.EDUCATOR]: EducatorAccountSettings,
  [UserType.COLLEGE_PORTAL_USER]: CollegePortalAccountSettings,
  [UserType.PUBLIC]: () => null,
};

export const mobileAccountSettingsRoutesForPortal = (portal: UserType) =>
  Object.values(ACCOUNT_SETTING_ROUTES)
    .filter((route) => route.portals.includes(portal))
    .map((route) => ({
      path: route.path,
      component: MOBILE_ACCOUNT_SETTINGS_COMPONENTS[portal],
      navbar: <MobileSubpageTitle title={route.label} />,
    }));
